import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Video } from '../_models/Video';
import { BaseService } from '../_shared/base.service';
import { S3Service } from './s3.service';
import { getUrl } from '../_shared/utils';
import * as moment from 'moment';
import { map, mergeMap } from 'rxjs/operators';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class VideoService extends BaseService {
    userToken: any;

    constructor(private http: HttpClient, private s3Service: S3Service, jwtTokenService: JWTTokenService) {
        super(http, jwtTokenService);
    }

    getVideos(): Observable<Video[]> {
        return this.HttpGet('assets/video');
    }

    uploadVideo(videoFile: File): Observable<Video> {
        if (videoFile == null) { return; }

        return this.getDuration(videoFile).pipe(
            mergeMap(time => {
              const duration = moment.duration(time, 'seconds');
              const hours = duration.hours() < 10 ? '0' + duration.hours().toString() : duration.hours().toString();
              const minutes = duration.minutes() < 10 ? '0' + duration.minutes().toString() : duration.minutes().toString();
              const seconds = duration.seconds() < 10 ? '0' + duration.seconds().toString() : duration.seconds().toString();
              const durationString = hours + ':' + minutes + ':' + seconds;
              const body: any = {
                VideoName: videoFile.name,
                VideoDuration: durationString
              };
              
              return this.http.post<Video>(getUrl('assets/video'), body, this.buildOptions());
          }), 
            mergeMap(video => {
              return this.s3Service.uploadFile(videoFile, video.folderName.toLowerCase().replace(/ /g, '-'), "get-signed-s3-url").pipe(map(s3Res => video));
          }));
    }


    public getDuration(video: File): Observable<number> {
        return new Observable(subscriber => {
          const videoElement = document.createElement('video');
          videoElement.src = URL.createObjectURL(video);

          videoElement.addEventListener('loadeddata', function () {
            subscriber.next(videoElement.duration);
            subscriber.complete();
            URL.revokeObjectURL(videoElement.src);
          });
        });
      }
}

